var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormDialog',{attrs:{"is-visible":_vm.isVisible,"title":_vm.model?.id ? 'Изменение группы' : 'Новая группа'},on:{"abort":_vm.finish,"save":_vm.save}},[(_vm.model)?_c('DeviceGroupForm',{attrs:{"errors":_vm.errors},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }